const config = {
  // 开发环境
  development: {
    HOST_TITLE: '(开发环境)',
    API_HOST: 'https://api4-dev.fccs.com',
    API_HOST_MAP: '/api-map',
    API_HOST_CHAT: '/api-chat',
    API_HOST_QA: '/api-qa',
    API_HOST_EXPO: 'https://house-expo.fccs.com',
    UPLOAD_API_HOST: '',
    BAIDU_MAP_AK: '',
    WECHAT_APP_ID: 'wx0d01013ba592ddf2',
    DEFAULT_CITYINFO: {
      city: 31,
      cityName: '上海',
      url: 'sh.fccs.com',
      shortDomain: 'sh',
      cletter: 's',
      phone400NotUse: 0,
      province: '上海',
      province0: '上海',
      bmapx: 121.481174,
      bmapy: 31.234681,
    },
    // 默认定位
    DEFAULT_LOCATION: {
      longitude: 120.75873747070312,
      latitude: 30.753931136855215,
    },
    GLOBAL_HOST: 'http://m.fccs.com',
    SSLWX: '',
  },
  // 测试环境
  preview: {
    HOST_TITLE: '(测试环境)',
    API_HOST: 'https://api4-dev.fccs.com',
    API_HOST_CHAT: 'https://api4-dev.fccs.com',
    API_HOST_QA: 'https://api4-seo-dev.fccs.com',
    API_HOST_EXPO: 'https://house-expo-dev.fccs.com',
    HOST_CHAT: 'https://api4-dev.fccs.com',
    UPLOAD_API_HOST: '',
    BAIDU_MAP_AK: '',
    WECHAT_APP_ID: 'wx0d01013ba592ddf2',
    // 默认站点
    DEFAULT_CITYINFO: {
      city: 31,
      cityName: '上海',
      url: 'sh.fccs.com',
      shortDomain: 'sh',
      cletter: 's',
      phone400NotUse: 0,
      province: '上海',
      province0: '上海',
      bmapx: 121.481174,
      bmapy: 31.234681,
    },
    // 默认定位
    DEFAULT_LOCATION: {
      longitude: 121.4737200000,
      latitude: 31.2303500000,
    },
    GLOBAL_HOST: '//m.fccs.com',
    SSLWX: 'https:',
  },
  // 生产环境配置
  production: {
    HOST_TITLE: '(生产环境)',
    API_HOST: 'https://api4.fccs.com',
    API_HOST_CHAT: 'https://api4.fccs.com',
    API_HOST_QA: 'https://api4-seo.fccs.com',
    API_HOST_EXPO: 'https://house-expo.fccs.com',
    HOST_CHAT: 'https://api4.fccs.com',
    UPLOAD_API_HOST: '',
    BAIDU_MAP_AK: '',
    WECHAT_APP_ID: 'wx2c872ee94c7fc3eb',
    // 默认站点
    DEFAULT_CITYINFO: {
      city: 31,
      cityName: '上海',
      url: 'sh.fccs.com',
      shortDomain: 'sh',
      cletter: 's',
      phone400NotUse: 0,
      province: '上海',
      province0: '上海',
      bmapx: 121.481174,
      bmapy: 31.234681,
    },
    // 默认定位
    DEFAULT_LOCATION: {
      longitude: 121.4737200000,
      latitude: 31.2303500000,
    },
    GLOBAL_HOST: '//m.fccs.com',
    SSLWX: 'https:',
  },
  // 公用配置
  common: {
    COOKIEOPTIONS: { domain: '.fccs.com', expires: 7, path: '/' },
    SSL: '//',
    // 默认房源图片
    DEFAULT_HOUSE_PIC: '//imgf1.fccs.com.cn/small-programe/images/no-pic-default-1.jpg',
    // 默认头像
    DEFAULT_HEAD_PIC: '//imgf1.fccs.com.cn/small-programe/v2/images/defaultphoto.png',
    // 默认地图图标
    MAP_ICON_PATH: 'https://imgf1.fccs.com.cn/small-programe/images/location.png',
    // 正则校验
    REGULARS: {
      // 邮箱
      email: /^([\w\-.\u4E00-\u9FA5])+@([\w\-.])+\.([A-Z]{2,8})$/i,
      // 身份证
      idNumber: /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9X])$/,
      // 手机号
      mobile: /^1\d{10}$/,
      // 特殊字符
      // eslint-disable-next-line prefer-regex-literals
      specialCharacters: new RegExp('[`~!@#$^&*()=|{}\':;,[\\].<>/?！￥…（）—【】‘；：”“。，、？%+_]'),
      // 验证码
      captcha: /\d{4}$/,
      // 筛选字母匹配
      filterLetter: /[a-z]+/i,
      // 文件后缀名
      fileExt: /(\.[^.]+$)/gm,
    },
    // 百度地图开发者平台
    STATIC_MAP: {
      key: 'A6W18qGEcsI1uU379ovvAsTZOuwpvY7n',
    },
    // 通用400电话
    PHONE400: '400-890-1122',
    // 发送验证码倒计时
    SMSSENDTIME: 60,
    // 测试站点
    TEST_CITYINFO: {
      city: 831,
      site: '8.3.1.',
      cityName: '测试',
      areaSpell: 'cs',
      cletter: 'c',
      url: 'test.fccs.com',
      shortDomain: 'test',
      cityTable: 'B',
      bmapx: 112.208633,
      bmapy: 31.000092,
      bmapz: 19,
      cityOperate: 3,
      cityLevel: 3.1,
      phone400NotUse: 0,
    },
    // url后缀
    EXT_URL: '.html',
    // echart图表配置
    ECHART: {
      color: ['#36bf3c', '#fd6300', '#2988ea', '#f9b74d'],
    },
    // 无值默认值
    DEFAULT_TXT: '暂无资料',
    // 域名
    SHARE_LOGO_ICO: 'https://imgf1.fccs.com.cn/public/img/share-logo.jpg',
  },
}

export default {
  // eslint-disable-next-line node/prefer-global/process
  ...config[process.env.NODE_ENV],
  ...config.common,
}
